import type { SVGProps } from 'react';

import * as styles from './LegacyAdviceAndTipsIcon.css';

export const LegacyAdviceAndTipsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    className={styles.lightBulbIcon}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    // xml:space="preserve"
  >
    <path
      d="M10.6,1.8c0.4,0.4,0.7,0.9,1,1.4c0.2,0.5,0.3,1.1,0.3,1.7c0,0.4-0.1,0.8-0.2,1.3S11.4,7,11.2,7.3h0l0,0
      c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0l-0.2,0.2c0,0-0.1,0.2-0.2,0.4c-0.1,0.2-0.3,0.5-0.4,0.8C10.2,9.2,10,9.6,9.9,10
      c-0.1,0.4-0.2,0.9-0.2,1.3v0.8c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1H5.6c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3
      v-0.8c0-0.5-0.1-0.9-0.2-1.3C4.8,9.6,4.7,9.2,4.5,8.8C4.4,8.5,4.3,8.2,4.1,8C4,7.8,3.9,7.7,3.9,7.6L3.8,7.5v0c0,0,0,0,0,0s0,0,0,0
      c0,0,0,0,0,0s0,0,0,0C3.5,7.1,3.3,6.7,3.2,6.2C3.1,5.8,3,5.4,3,4.9c0-0.6,0.1-1.1,0.3-1.7c0.2-0.5,0.5-1,1-1.4s0.9-0.7,1.4-1
      c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3S10.1,1.4,10.6,1.8z M10.8,5.9c0.1-0.3,0.1-0.7,0.1-1c0-0.5-0.1-0.9-0.3-1.3
      c-0.2-0.4-0.4-0.8-0.8-1.1C9.6,2.1,9.2,1.9,8.8,1.7C8.3,1.5,7.9,1.4,7.4,1.4c-0.5,0-0.9,0.1-1.4,0.3C5.6,1.9,5.3,2.1,5,2.5
      C4.6,2.8,4.4,3.1,4.2,3.6S3.9,4.4,3.9,4.9c0,0.4,0.1,0.7,0.2,1c0.1,0.3,0.3,0.6,0.4,0.9c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
      s0,0,0,0l0.1,0.1c0,0,0,0,0,0s0,0,0,0c0,0,0.2,0.3,0.5,0.8c0.3,0.5,0.5,1.2,0.7,1.9h0.5L5.6,7.2c0-0.1,0-0.2,0-0.3s0.1-0.2,0.2-0.2
      C5.8,6.6,5.9,6.6,6,6.6c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0.1,0.2,0.1C6.6,6.9,6.8,6.9,7,7C7.3,7,7.5,7,7.8,7c0.3-0.1,0.5-0.2,0.8-0.3
      c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.2s0,0.2,0,0.3L8.7,9.8H9c0.2-0.8,0.4-1.4,0.7-1.9
      c0.3-0.5,0.4-0.8,0.5-0.8c0,0,0,0,0,0l0.2-0.2c0,0,0,0,0,0c0,0,0,0,0,0C10.5,6.5,10.7,6.2,10.8,5.9z M9.6,13.7
      c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1H5.6c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3
      c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h3.7C9.4,13.6,9.5,13.6,9.6,13.7z M8.8,10.8H6v0.9h2.8V10.8z M7.3,9.8
      C7.3,9.8,7.3,9.8,7.3,9.8l0.5,0l0.4-2C7.9,7.9,7.6,8,7.4,8c-0.2,0-0.5,0-0.6-0.1h0L7.3,9.8z"
    />
  </svg>
);
